<script lang="ts">
const __DsBlock = {
	type: 'input',
	icon: 'lucide:palette',
	name: '$t:blocks.input_color.name',
	description: '$t:blocks.input_color.description',
	category: 'input',
	fieldBinding: { supportedTypes: ['color'] },

	options: [
		{
			name: 'modelValue',
			model: true,
		},
		{
			name: 'color',
			type: 'enum',
			values: BLOCK_COLOR_OPTIONS,
		},
		{
			name: 'variant',
			type: 'enum',
			values: BLOCK_INPUT_VARIANT_OPTIONS,
		},
		{
			name: 'size',
			type: 'enum',
			values: BLOCK_CONTROL_SIZE_OPTIONS,
		},
		{
			name: 'placeholder',
		},
		{
			name: 'disabled',
		},
		{
			name: 'readonly',
		},
		{
			name: 'disabledNotice',
		},
	],
}
</script>
<script lang="ts" setup>
import type { InputColorProps } from '#layers/ui';
import type { InputBlockProps } from '~/types/input-block';
import { reactivePick } from '@vueuse/core';
import { defineBlock } from '#layers/block-engine';
import { BLOCK_COLOR_OPTIONS, BLOCK_CONTROL_SIZE_OPTIONS, BLOCK_INPUT_VARIANT_OPTIONS } from '#layers/blocks/constants/ui-options';
import { useDisabledNotice } from '#layers/ui';
import { usePrimitiveFormField } from '~/composables/form-block/use-primitive-form-field';

interface Props extends
	InputBlockProps,
	Pick<InputColorProps, 'color' | 'variant' | 'size' | 'placeholder'> {}

const props = defineProps<Props>();
const forwarded = reactivePick(props, 'color', 'variant', 'size', 'placeholder', 'readonly');

;

const model = defineModel<string | null>();
const { modelValue, disabled, disabledNotice, nullable } = usePrimitiveFormField(props, { model });
const { showDisabledNotice } = useDisabledNotice({ disabled, disabledNotice });
</script>

<template>
	<DTooltip :delay-duration="0" :disabled="!showDisabledNotice" :text="disabledNotice">
		<!-- TODO: <div> necessary because DTooltip doesn't play nice with DInputColor (tooltip doesn't show up) -->
		<div>
			<DInputColor
				v-bind="forwarded"
				v-model="modelValue"
				:disabled
				:aria-readonly="readonly"
				:clear="nullable"
				block
			/>
		</div>
	</DTooltip>
</template>
